const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M248.7,130.5h-18c-1.4,0-2.6,1.2-2.6,2.6v99H24.9V28.9h99.2c1.4,0,2.6-1.1,2.6-2.6h0V8.3c0-1.4-1.2-2.6-2.6-2.6H23.6C11.5,5.7,1.8,15.5,1.8,27.6v205.7c0,12.1,9.8,21.9,21.9,21.9h205.7c12.1,0,21.9-9.8,21.9-21.9v-100.3c0-1.4-1.2-2.6-2.6-2.6,0,0,0,0,0,0h0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.7,32.5l-25-25c-8-8-21.1-8-29.1,0l-114.7,114.7c-1.9,2-3.2,4.5-3.6,7.2h0s-6.1,42.1-6.1,42.1c-1,7,3.8,13.6,10.9,14.6,1.2.2,2.5.2,3.7,0l42.1-6.2c2.7-.4,5.3-1.7,7.2-3.6l114.7-114.7c8-8,8-21.1,0-29.1ZM122.4,159.9l-29.3,4.3,4.3-29.3h0S210.2,22,210.2,22l25,25-112.9,112.9Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e86c0bc71415b3944e24cd726ad51b7d.svg";
export { ForwardRef as ReactComponent };